export const GET_ALL_TAGS = 'tags/GET_ALL_TAGS';
export const SET_ADD_EDIT_TAG_MODAL_STATE = 'tags/SET_ADD_EDIT_TAG_MODAL_STATE';